import { css } from 'linaria';

export const variantItemWrap = css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  font-size: 14px;
  line-height: 20px;
  text-decoration: none;
  color: #333333;
  border: 1px solid #d2d4d8;
  border-radius: 4px;
  user-select: none;
  white-space: nowrap;
  &:active {
    -webkit-transform: scale(0.95);
    -ms-transform: scale(0.95);
    transform: scale(0.95);
    transition: all 0.2s ease;
  }
  @media (hover: hover) {
    &:hover {
      border-color: var(--control-hover-secondary);
    }
  }
`;

export const variantItemWrapInactive = css`
  color: #b0b0b0;

  background: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 2px,
    transparent 2px,
    transparent 4px,
    rgb(240, 241, 242) 5px,
    rgb(240, 241, 242) 6px
  );
`;

export const disabledFromSelect = css`
  pointer-events: none;
`;

export const variantLink = css`
  display: block;
  padding: 9px 18px;
  text-decoration: none;
  color: inherit;
`;

export const variantImageLink = css`
  display: block;
  padding: 4px;
`;

export const variantItemWrapActive = css`
  font-weight: 500;
  border-width: 2px;
  border-color: var(--control-primary);

  & > .${variantLink} {
    padding: 8px 18px;
  }

  & > .${variantImageLink} {
    padding: 3px;
  }
`;

export const variantItemDrawerWrapInactive = css`
  background-color: var(--control-minor);
  opacity: 0.4;
`;

export const variantDrawerLink = css`
  display: block;
  padding: var(--space-150) var(--space-300);
  text-decoration: none;
  color: inherit;
`;

export const variantImageDrawerLink = css`
  display: block;
  padding: var(--space-200);
`;

export const variantItemDrawerWrapActive = css`
  font-weight: 500;
  border-width: 2px;
  border-color: var(--control-primary);

  & > .${variantLink} {
    padding: var(--space-150) var(--space-300);
  }

  & > .${variantImageLink} {
    padding: var(--space-200);
  }

  &:hover {
    border-color: var(--control-primary);
  }
`;
